export const API_RES = {

    LOGIN:{
        SUCCESS: "Successfully logged in",
    },
    SETTING_ENABLE_SUCCESS:'Enabled',
    SETTING_ENABLE_FAILED:"Can't enable",
    ENABLE_EMAIL_REMINDER:'Please enable email reminder first',
    SEND_EMAIL_MSG_SUCCESS:"Email reminder sent successfully",
    SEND_EMAIL_MSG_FAILED:"Email can't send",
}